import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { SidebarListComponent } from '@app/components';
import { CircularProgress } from '@material-ui/core';

export function SidebarComponent() {
    const shellLoading: boolean = useSelector((state: any) => state.basic.shellConfigLoading);
    const shellConfig = useSelector((state: any) => state.basic.shellConfig);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const sidebarClass = (): string => {
        let classes: string = 'main__sidebar sidebar';

        return isCollapsed ? `${classes} main__sidebar-small` : classes;
    };

    const arrowClass = (): string => {
        let classes: string = 'main__sidebar-arrow';

        return isCollapsed ? `${classes} main__sidebar-arrow-collapsed` : classes;
    };

    const handleArrowClick = (): void => {
        setIsCollapsed((prevValue) => !prevValue);
    };

    return (
        <div className={sidebarClass()}>
            {!shellLoading && shellConfig.apps && shellConfig.apps.length > 0 && <SidebarListComponent isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}

            {shellLoading && <CircularProgress />}
            <div className={arrowClass()} onClick={handleArrowClick} />
        </div>
    );
}
